/* eslint-disable import/no-cycle */
/* eslint-disable no-underscore-dangle */
import _ from 'lodash';
import store from 'shared/redux/store';
import {
  registerAccount,
  getStepStatus,
  generateChannel,
  refreshApp,
  websocketConnect,
} from 'shared/redux/actions';
import { ACTION_TYPE } from 'shared/redux/actions/actionTypes';
import {
  PATH,
  STORAGE_KEY,
  expirationTime,
  WEBSOCKET_STATUS_NOT_CONNECTED,
  WEBSOCKET_STATUS_CLOSED,
  COMPONENT_TYPE,
  CUSTOME_STOP_STEP,
  EMAIL_THREAD,
} from 'shared/constants';
import {
  idleTimer,
  // clearIdleTimer,
} from 'shared/util/idleTimer';
import api from 'shared/services/api';
import {
  browserName, isIOS, osName, isTablet, isMobileOnly,
} from 'react-device-detect';
import * as serviceWorker from './serviceWorker';
import {
  trackUniqueUser, trackReturnVisitor, trackDropOff, trackPWAInstalled,
  trackDevice, trackBrowser, trackCountry,
} from './App.tracking';


export const refreshUser = () => {
  store.dispatch(refreshApp()).then(() => {
    store.dispatch({ type: ACTION_TYPE.REFRESH_USER });
    store.dispatch(generateChannel());
    window.location.replace(PATH.HOME);
  });
};

export const handleRegisterAccount = (tracking) => {
  const {
    userInfo,
    websocketStatus,
  } = store.getState().rootReducer;
  if (!(userInfo && userInfo._id)) {
    // if user is not exists then create a new account
    store.dispatch(registerAccount()).then((res) => {
      if (websocketStatus === WEBSOCKET_STATUS_NOT_CONNECTED || websocketStatus === WEBSOCKET_STATUS_CLOSED) {
        store.dispatch(websocketConnect());
      }
      /** track unique user */
      trackUniqueUser(tracking, res);
      /** */
    });
  } else {
    /** track return visitor */
    trackReturnVisitor(tracking, userInfo);
    /** */
  }
};

export const handleRefreshApp = (timer) => {
  const {
    userInfo,
    isStartStep,
    summary,
    websocketStatus,
  } = store.getState().rootReducer;
  /** refresh user function */
  const expirationDate = JSON.parse(localStorage.getItem(STORAGE_KEY.EXPIRATION_DATE));
  const rightNow = new Date().getTime();
  const expirationCondi = expirationDate && (rightNow - expirationDate) >= expirationTime;

  // refresh user after 15 mins unuse
  if (expirationCondi && isStartStep && !_.isEmpty(summary)) {
    refreshUser();
  } else {
    serviceWorker.register();
    // detect country origin/ browser/ device
    if ((userInfo && userInfo._id)
    && (websocketStatus === WEBSOCKET_STATUS_NOT_CONNECTED || websocketStatus === WEBSOCKET_STATUS_CLOSED)) {
    // connect to botkit
      store.dispatch(websocketConnect());
    }
  }

  // refresh user after 15 mins inactive
  idleTimer(timer, '.App', () => {
    // // we only clear the data if user has already answer at least one question!
    if (localStorage.getItem('state') && JSON.parse(localStorage.getItem('state')).isStartStep) {
      refreshUser();
    }
  }, expirationTime);

  // if the user is valid then get the status
  if (!expirationCondi && !_.isEmpty(summary)) {
    store.dispatch(getStepStatus());
  }
};

export const detectOnVisibilityChange = (tracking) => {
  let hidden;
  let visibilityChange;
  if (typeof document.hidden !== 'undefined') {
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.mozHidden !== 'undefined') {
    hidden = 'mozHidden';
    visibilityChange = 'mozvisibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  } else {
    console.log('Page Visibility API not supported.');
  }

  const getEmailComponentType = (currentThreadForTracking) => {
    switch (currentThreadForTracking) {
      case EMAIL_THREAD.PROCEED_ACTION:
        return { step: CUSTOME_STOP_STEP.SIMULATION_ONLY, thread: `${EMAIL_THREAD.EMAIL_THREAD}_${CUSTOME_STOP_STEP.SIMULATION_ONLY}` };
      case EMAIL_THREAD.SELECT_APPLICATION:
        return { step: CUSTOME_STOP_STEP.OPEN_ACCOUNT_LATER, thread: `${EMAIL_THREAD.EMAIL_THREAD}_${CUSTOME_STOP_STEP.OPEN_ACCOUNT_LATER}` };
      case EMAIL_THREAD.SELECT_TIME:
        return { step: CUSTOME_STOP_STEP.APPOINTMENT_EMAIL, thread: `${EMAIL_THREAD.EMAIL_THREAD}_${CUSTOME_STOP_STEP.APPOINTMENT_EMAIL}` };
      default:
        return '';
    }
  };
  function handleVisibilityChange() {
    const state = { ...store.getState().rootReducer };

    let componentType = state.inputComponent;
    const componentTypeToCheck = componentType;
    let stopThread = state.currentThread;
    switch (componentTypeToCheck) {
      case COMPONENT_TYPE.EMAIL:
        const { step, thread } = getEmailComponentType(state.currentThreadForTracking);

        componentType = step;
        stopThread = thread;
        break;
      case COMPONENT_TYPE.OPTIONAL_EMAIL:
        componentType = CUSTOME_STOP_STEP.OPEN_ACCOUNT_NOW;
        stopThread = `${EMAIL_THREAD.EMAIL_THREAD}_${CUSTOME_STOP_STEP.OPEN_ACCOUNT_NOW}`;
        break;
      case COMPONENT_TYPE.DATE_PICKER:
        componentType = CUSTOME_STOP_STEP.APPOINTMENT_DATEPICKER;
        break;
      case COMPONENT_TYPE.TIME_PICKER:
        componentType = CUSTOME_STOP_STEP.APPOINTMENT_TIMEPICKER;
        break;
      case COMPONENT_TYPE.PHONE_NUMBER:
        componentType = CUSTOME_STOP_STEP.APPOINTMENT_PHONE;
        break;
      default:
        break;
    }

    if (document[hidden]) {
      const data = {
        stopStep: componentType,
        stopThread,
      };
      trackDropOff(tracking, data);
    }
  }
  document.addEventListener(visibilityChange, handleVisibilityChange, false);
};

export const initialTracking = (tracking) => {
  setTimeout(() => {
    api.countryDetector().then((res) => {
      trackCountry(tracking, res);
    });
    console.log(`isMobileOnly ${isMobileOnly} isisTablet ${isTablet} `);
    let deviceType = 'desktop';
    if (isMobileOnly) {
      deviceType = 'mobile';
    } else if (isTablet) {
      deviceType = 'tablet';
    }
    // track device
    trackDevice(tracking, deviceType);
    // track browser
    trackBrowser(tracking, browserName);

    // if PWA on IOS device
    if (window.navigator.standalone === true) {
      trackPWAInstalled(tracking, osName);
      // console.log('display mode stand alone on IOS!');
    }

    // if PWA on others device
    if (window.matchMedia('(display-mode: standalone)').matches && !isIOS) {
      trackPWAInstalled(tracking, osName);
      // console.log('display mode stand alone except IOS!');
    }
    // window.onappinstalled = () => {
    //   trackPWAInstalled(tracking, userInfo);
    // console.log('Thank you for installing our app!');
    // };
  }, 3000);
};
